// Icons an area may use — must match AreaService::ALLOWED_ICONS on the backend.
// Labels are i18n keys (translated where shown).
export const AREA_ICONS = [
  { icon: "bi-p-circle",          label: "Parking" },
  { icon: "bi-p-square",          label: "Parking (square)" },
  { icon: "bi-building-down",     label: "Underground garage" },
  { icon: "bi-building-up",       label: "Multi-storey car park" },
  { icon: "bi-layers",            label: "Underground" },
  { icon: "bi-car-front",         label: "Car park" },
  { icon: "bi-ev-station",        label: "EV charging" },
  { icon: "bi-person-wheelchair", label: "Accessible parking" },
  { icon: "bi-key",               label: "Staff / reserved" },
  { icon: "bi-shield-check",      label: "Secured area" },
  { icon: "bi-cone-striped",      label: "Construction" },
  { icon: "bi-truck",             label: "Logistics" },
  { icon: "bi-bus-front",         label: "Bus / coach parking" },
  { icon: "bi-train-front",       label: "Park & Ride" },
  { icon: "bi-bicycle",           label: "Bicycle" },
  { icon: "bi-airplane",          label: "Airport" },
  { icon: "bi-fuel-pump",         label: "Petrol station" },
  { icon: "bi-building",          label: "Building" },
  { icon: "bi-buildings",         label: "Multi-building" },
  { icon: "bi-briefcase",         label: "Office" },
  { icon: "bi-easel",             label: "Conference centre" },
  { icon: "bi-bank",              label: "Public authority" },
  { icon: "bi-shop",              label: "Retail" },
  { icon: "bi-cart3",             label: "Supermarket" },
  { icon: "bi-cup-hot",           label: "Restaurant / caf\u00e9" },
  { icon: "bi-suitcase-lg",       label: "Hotel" },
  { icon: "bi-house",             label: "Residential" },
  { icon: "bi-hospital",          label: "Hospital" },
  { icon: "bi-heart-pulse",       label: "Medical centre" },
  { icon: "bi-mortarboard",       label: "School / university" },
  { icon: "bi-trophy",            label: "Sports venue" },
  { icon: "bi-dribbble",          label: "Sports field" },
  { icon: "bi-ticket-perforated", label: "Event venue" },
  { icon: "bi-music-note-beamed", label: "Concert hall" },
  { icon: "bi-film",              label: "Cinema" },
  { icon: "bi-tree",              label: "Park / nature" },
  { icon: "bi-water",             label: "Lake / swimming pool" },
  { icon: "bi-signpost-2",        label: "Tourism" },
];
